
define('text!modules/reporting/segments/dataExport/createEdit/templates/report-type.html',[],function () { return '<strand-header class="report-type-title" size="small">Report Type</strand-header>\n<strand-dropdown class="report-select" fitparent="true">\n\t{{#reports}}\n\t<strand-list-item>{{report}}</strand-list-item>\n\t{{/reports}}\n</strand-dropdown>';});

